module.exports = __webpack_public_path__ + "img/Notifs.8e881e29.png";